import { generatePath } from 'react-router';
import { urlSafeString } from 'utils';

//------------------------------------------------------------------------------------------------
// Patterns
//------------------------------------------------------------------------------------------------
export const scenePattern = '/project/:sceneId/:sceneTitle';
export const framePattern = '/frame/:frameId/:frameTitle';
export const profilePattern = '/profile';
export const designSystemPattern = '/ds/:designSystemId/:designSystemTitle';
export const createDesignSystemPattern = '/create-ds';

//------------------------------------------------------------------------------------------------
// Routes
//------------------------------------------------------------------------------------------------
export function home(): string {
	return '/';
}

export function scene(sceneId: string, sceneTitle: string): string {
	const safeTitle = urlSafeString(sceneTitle ?? 'Untitled');
	return generatePath(scenePattern, { sceneId, sceneTitle: safeTitle });
}

export function frame(
	sceneId: string,
	sceneTitle: string,
	frameId: string,
	queryParams: Record<string, string> = {}
): string {
	const safeTitle = urlSafeString(sceneTitle ?? 'Untitled');
	const path = generatePath(scenePattern, { sceneId, sceneTitle: safeTitle });
	const params = new URLSearchParams({ ...queryParams, frameId });
	return path + '?' + params.toString();
}

export function profile(): string {
	return '/profile';
}

export function designSystem(designSystemId: string, designSystemTitle: string): string {
	const safeTitle = urlSafeString(designSystemTitle ?? 'Untitled');
	return generatePath(designSystemPattern, { designSystemId, designSystemTitle: safeTitle });
}

export function createDesignSystem(sceneId?: string): string {
	if (sceneId) {
		return `${createDesignSystemPattern}?sceneId=${sceneId}`;
	}
	return createDesignSystemPattern;
}

export function modifyCurrentPath(
	queryParams: Record<string, string>,
	mergeWithExistingParams: boolean = false
): string {
	let params: URLSearchParams | undefined = undefined;
	if (mergeWithExistingParams) {
		params = new URLSearchParams(window.location.search);
		for (const [key, value] of Object.entries(queryParams)) {
			params.set(key, value);
		}
	} else {
		params = new URLSearchParams(queryParams);
	}
	return window.location.pathname + '?' + params.toString();
}
